import { Rating } from './rating';

export const RATINGS: Rating[] = [
  {
    title: 'traditional sustainability',
    image: 'https://www.rubicon.com/wp-content/uploads/2016/03/sustainability-3.jpg',
    Subitems: [{
      title: 'Target for scope',
      rating: 0,
      icon: '',
      today: 'We have this blabla',
      tomorrow: '',
      next: ''
    }, {
      title: 'Transparency/ Reporting',
      rating: 0,
      icon: '',
      today: '',
      tomorrow: '',
      next: ''
    }, {
      title: 'Credibility',
      rating: 0,
      icon: '',
      today: '',
      tomorrow: '',
      next: ''
    }]
  }, {
    title: 'Digitalization/ Service',
    image: 'http://www.techedgegroup.com/hubfs/Blog_Images/blog_digital_sustainability.png',
    Subitems: [{
      title: 'Digitalization',
      rating: 0,
      icon: '',
      today: '',
      tomorrow: '',
      next: ''
    }, {
      title: 'Service to Product',
      rating: 0,
      icon: '',
      today: '',
      tomorrow: '',
      next: ''
    }, {
      title: 'Credibility/ Network',
      rating: 0,
      icon: '',
      today: '',
      tomorrow: '',
      next: ''
    }]
  }, {
    title: 'Global sustainability',
    image: 'https://bsos.umd.edu/sites/bsos.umd.edu/files/sustainabilitymessaging.jpg',
    Subitems: [{
      title: 'Vision /Targets',
      rating: 0,
      icon: '',
      today: '',
      tomorrow: '',
      next: ''
    }, {
      title: 'Existing solutions',
      rating: 0,
      icon: '',
      today: '',
      tomorrow: '',
      next: ''
    }, {
      title: 'Potential solutions',
      rating: 0,
      icon: '',
      today: '',
      tomorrow: '',
      next: ''
    }]
  }
];



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/sustainability-rating/rating/ratings.ts